
import { Component, Vue } from 'vue-property-decorator'
import { QuestionAnswerType } from '@/mixins/requests/student/StudyApis.vue'

/**
 * SessionStorage情報取得処理を共通化するMixinコンポーネント
 */
@Component
export default class SessionStorageMethods extends Vue {
  // questionAnswers保存
  protected setQuestionAnswersSessionStorage(questionAnswers: QuestionAnswerType[]) {
    sessionStorage.setItem('acbtQuestionAnswers', JSON.stringify(questionAnswers))
  }

  // questionAnswers取得
  protected get questionAnswersSessionStorage(): QuestionAnswerType[] | null {
    const json = sessionStorage.getItem('acbtQuestionAnswers')
    if (!json) return null
    return JSON.parse(json) as QuestionAnswerType[]
  }

  protected clearSessionStorage(): void {
    sessionStorage.removeItem('acbtQuestionAnswers')
  }
}
